import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  showcollabos:boolean=false;
  searchText:any;
  tempcollaboList:any;
  presentCollabos: any;
  tempcol: any;
  private isCollapsed: boolean = true;
  constructor(private loginService:LoginService) { }

  ngOnInit(): void {
  }
  Getcollabos(){
  this.loginService.GetCollabos(1).subscribe(data=>
    {
        data = JSON.parse(data['_body']);
        this.tempcollaboList=JSON.parse(JSON.stringify(data));
        this.presentCollabos=this.tempcollaboList.filter(x=>x.status==1 || x.status==2);
    });
  }
}
